const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
};

export default function Avatar({ name, size = 'md', color = 'bg-blue-600' }) {
  const initials = (name || '?')
    .split(' ')
    .map(part => part[0] || '')
    .join('')
    .toUpperCase() || '?';

  return (
    <div
      className={`${sizeClasses[size]} ${color} rounded-full flex items-center justify-center font-semibold text-white`}
      title={name}
    >
      {initials}
    </div>
  );
}
